module.exports = __webpack_public_path__ + "static/media/casino-forgot-pass.dccd4ab9.png";